import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21 11.317a3.152 3.152 0 0 0-.3-.036c-2.62-.187-4.891-.281-6.817-.281-1.93 0-4.221.094-6.873.283a3.135 3.135 0 0 0-2.903 2.877A39.48 39.48 0 0 0 4 17.27c0 1.467.055 2.817.165 4.052a3.135 3.135 0 0 0 2.898 2.85 95.645 95.645 0 0 0 8.41.237l3.262 3.206a1.344 1.344 0 0 0 2.286-.959v-2.53a3.136 3.136 0 0 0 2.523-2.8 45.91 45.91 0 0 0 .165-4.055c0-.758-.015-1.456-.044-2.094A2 2 0 0 1 21 13.29v-1.973Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "SMS-Outbound-Filled_svg__a",
      width: 11,
      height: 11,
      x: 17,
      y: 4,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M23.424 13.714V5.951l3.596 3.596a.571.571 0 1 0 .808-.808l-4.562-4.563a.57.57 0 0 0-.828.002l-4.56 4.561a.572.572 0 0 0 .808.808l3.595-3.596v7.763a.571.571 0 1 0 1.143 0Z"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#SMS-Outbound-Filled_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "#00B388", d: "M29 15H17V3h12v12Z" }))
);
var SvgSmsOutboundFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SmsOutboundFilled_default = SvgSmsOutboundFilled;

export { SmsOutboundFilled_default as default };
